import React, {useEffect, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import {
    Button,
    Checkbox,
    Typography
} from "@mui/material";
import Box from "@mui/material/Box";
import {Link, useNavigate} from "react-router-dom";
import {modelParameterUnit} from "../../../../../data/ModelParameterUnit";
import {orderJobType} from "../../../../../data/OrderJobType";
import UtilityService from "../../../../../API/common/UtilityService";
import JobMetricOrganizationService from "../../../../../API/orders/job/JobMetricOrganizationService";
import ButtonCreate from "../../../button/ButtonCreate";
import MenuItem from "@mui/material/MenuItem";
import UnitService from "../../../../../API/orders/warehouse/UnitService";
import {typeMaterialWithSubtype} from "../../../../../data/TypeMaterial";
import {millingJob} from "../../../../../data/MillingJobType";
import {contourType} from "../../../../../data/ContourType";
import {grooveType} from "../../../../../data/GrooveType";
import {toolType} from "../../../../../data/ToolType";
import {gluing} from "../../../../../data/Gluing";
import {edgeEnd} from "../../../../../data/EdgeEnd";
import {edgeJob} from "../../../../../data/EdgeJob";
import selectionTableUtil, {normalizeSelection} from "../../../../../utils/common/SelectionTableUtil";
import ModalChooseJob from "./ModalModalChooseJob";
import ModalAddJobInAdmin from "./ModalAddJobInAdmin";
import MaterialOrganizationOptionService
    from "../../../../../API/orders/warehouse/material/MaterialOrganizationOptionService";
import ModalAddJob from "./ModalAddJob";
import MaterialService from "../../../../../API/material-cloud/admin/AdminMaterialMaterialCloudService";
import {replaceEmptyStringsOnNull} from "../../../../../utils/ReplaceEmptyStringsOnNull";

const JobMetricOrganizationTable = ({
                                        data,
                                        setData,
                                        enableEditing,
                                        isRedirectSettings,
                                        isChooseSignJob,
                                        enableRowSelection,
                                        rowSelection,
                                        setRowSelection,
                                        setRowIndexSelection,
                                        setSelectedIds,
                                        isPrice,
                                        isUnit,
                                        baseCurrency,
                                        alternativeCurrency,
                                        isModal,
                                        onlyName,
                                        selectedString,
                                        setSelectedString,
                                        fullWidth,
                                        columnAdded,
                                        tableOptions,
                                        tableOptionsHandle,
                                        handleModalAlert,
                                        admin,
                                        api,
                                        itemId,
                                        addJob,
                                        materialId,
                                        id,
                                        rowActions = true,
                                        settings,
                                        type,
                                        allCurrencies,
                                        notAuthorized,
                                        cloudModuleFromHeader,
                                        readOnly,
                                        added,
                                        globalFilter,
                                        handleSearchQuery,
                                        filteredData,
                                        columnsFilter,
                                        typeList
                                    }) => {

        const [modalChooseJob, setModalChooseJob] = useState(false);
        const [modalAddJob, setModalAddJob] = useState(false);
        const [currencies, setCurrencies] = useState([])
        const [listUnits, setListUnits] = useState([]);
        const [currentEditRowData, setCurrentEditRowData] = useState({});
        const [modalAddInAdmin, setModalAddInAdmin] = useState(false);
        const allMaterials = Object.values(typeMaterialWithSubtype)
        const allSubMaterials = allMaterials.reduce((acc, el) => {
            return [...acc, ...Object.entries(el.subtype)]
        }, [])
        const [showColumnFilters, setShowColumnFilters] = useState(false)

        const handleShowColumnFilters = () => {
            setShowColumnFilters(!showColumnFilters)
            if (showColumnFilters) {
                handleSearchQuery([], data, null, true)
            }
        }

        const {onRowSelectionChange} = selectionTableUtil(data, setRowSelection)
        const currentSelection = normalizeSelection(rowSelection)
        const [loading, setLoading] = useState(false)

        useEffect(() => {
            // allCurrencies ? setCurrencies(allCurrencies) :
            UtilityService.getCurrencies()
                .then(function (response) {
                    setCurrencies(response.data)
                }).catch(function (error) {
                handleModalAlert(error)
            })
            UnitService.getAll().then(function (response) {
                let data = response.data;
                setListUnits(data)
            })
                .catch(function (error) {
                    handleModalAlert(error);
                });
        }, []);
        const navigate = useNavigate();

        const redirectSettings = () => {
            navigate('/settings-orders');
        };

        const handleSubmitAddSign = (value) => {
            setLoading(true)
            JobMetricOrganizationService.create(currentEditRowData.metricName, value.currency, currentEditRowData.orderJobType, value.price)
                .then(function (response) {
                    const newData = data.map(el => el.metricName === response.data.metricName ? response.data : el)
                    setData(newData)
                    handleSearchQuery(globalFilter, newData)
                    handleModalAlert("Работа добавлена", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error)
                })
                .finally(() => setLoading(false))
        }
        const handleEditPrice = (value) => {
            setLoading(true)
            JobMetricOrganizationService.update(currentEditRowData.id, value.currency, value.price)
                .then(function (response) {
                    const newData = data.map(el => el.metricName === response.data.metricName ? {
                        ...el,
                        alternativePrice: response.data.alternativePrice,
                        basePrice: response.data.basePrice
                    } : el)
                    setData(newData)
                    handleSearchQuery(globalFilter, newData)
                    handleModalAlert("Задана новая стоимость", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error)
                })
                .finally(() => setLoading(false))
        }
        const handleSubmitAddJob = (ids, addedData) => {
            setLoading(true)
            if (admin) {
                MaterialService.addJobMetric(id, {"ids": ids}, type).then(function (response) {
                    const newData = [...data, ...addedData]
                    setData(newData)
                    handleSearchQuery(globalFilter, newData)
                    setModalAddJob(false)
                    handleModalAlert("Работы добавлены", 'success')
                })
                    .catch(function (error) {
                        handleModalAlert(error);
                    })
                    .finally(() => setLoading(false))
            } else {
                MaterialOrganizationOptionService.addJobMetric(id, {"ids": ids}).then(function (response) {
                    const newData = [...data, ...addedData]
                    setData(newData)
                    handleSearchQuery(globalFilter, newData)
                    setModalAddJob(false)
                    handleModalAlert("Работы добавлены", 'success')
                })
                    .catch(function (error) {
                        handleModalAlert(error);
                    })
                    .finally(() => setLoading(false))
            }

        }
        const handleDelete = (row) => {
            api.delete(row.id)
                .then(function () {
                    const newData = data.filter(el => el.id !== row.id)
                    setData(newData)
                    handleSearchQuery(globalFilter, newData)
                    handleModalAlert("Данные удалены", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
        }
        const handleSubmitModalAdmin = (value) => {
            setLoading(true)
            currentEditRowData.id ? api.update(replaceEmptyStringsOnNull(replaceEmptyStringsOnNull(value)), value.id)
                    .then(function (response) {
                        const newData = data.map(el => el.id === currentEditRowData.id ? response.data : el)
                        setData(newData)
                        handleSearchQuery(globalFilter, newData)
                        setModalAddInAdmin(false)
                        handleModalAlert("Данные изменены", 'success')
                    })
                    .catch(function (error) {
                        handleModalAlert(error);
                    })
                    .finally(() => setLoading(false))
                : api.create(replaceEmptyStringsOnNull(value))
                    .then(function (response) {
                        const newData = [...data, response.data]
                        setData(newData)
                        handleSearchQuery(globalFilter, newData)
                        setModalAddInAdmin(false)
                        handleModalAlert("Данные изменены", 'success')
                    })
                    .catch(function (error) {
                        handleModalAlert(error);
                    })
                    .finally(() => setLoading(false))
        }
        const handleEdit = (row) => {
            if (admin) {
                setModalAddInAdmin(true)
            } else {
                setModalChooseJob(true)
            }
            setCurrentEditRowData(row)
        }

        const handleChange = (row) => {
            if (row?.added) {
                JobMetricOrganizationService.delete(row.id)
                    .then(function (response) {
                        const newData = data.map(el => el.metricName === row.metricName ? {
                            ...row,
                            added: false,
                            basePrice: null,
                            alternativePrice: null
                        } : el)
                        setData(newData)
                        handleSearchQuery(globalFilter, newData)
                        handleModalAlert("Данные изменены", 'success')
                    }).catch(function (error) {
                    handleModalAlert(error)
                })
            } else {
                setCurrentEditRowData(row)
                setModalChooseJob(true)
            }
        }
        const sortArr = {"CUT": 0, "MILLING": 1, "EDGE": 2, "DRILLING": 3, "PACKAGING": 4}

        const handleAdd = () => {
            if (admin && settings) {
                const initData = columns.reduce((acc, el) => ({
                    ...acc,
                    [el.accessorKey]: el.checkBox === true ? true : ""
                }), {})
                setCurrentEditRowData(initData)
                setModalAddInAdmin(true)
            } else {
                setModalAddJob(true)
            }

        }
        const idNameColumn = (admin || cloudModuleFromHeader) ? "name" : "metricName"

        const columns = useMemo(() => {
            const baseColumns = [
                {
                    id: idNameColumn,
                    header: 'Наименование операции',
                    accessorKey: idNameColumn,
                    enableEditing: false,
                    enableGrouping: true,
                    minSize: 35,
                    Cell: ({cell, row}) => (row.original?.added && !isModal ?
                        <Link to={`/settings/signJob/${row.original.id}`}>{cell.getValue()}</Link> : cell.getValue()),
                },

                {
                    id: "orderJobType",
                    header: `Тип работ`,
                    accessorKey: 'orderJobType',
                    size: 8,
                    filterVariant: 'multi-select',
                    filterSelectOptions: typeList,
                    Cell: ({cell}) => orderJobType[cell.getValue()],
                    enableSorting: !admin,
                    muiFilterTextFieldProps: {
                        placeholder: 'Отфильтровать по типу работ',
                        sx: {
                            width: '120px',
                        },
                    }
                },
                {
                    id: "modelParameterUnit",
                    header: 'Параметр с модели',
                    accessorKey: 'modelParameterUnit',
                    enableEditing: false,
                    enableGrouping: true,
                    minSize: 280,
                    Cell: ({cell}) => modelParameterUnit[cell.getValue()],
                },
                {
                    header: 'id',
                    accessorKey: 'id',
                    enableHiding: false,
                    enableColumnActions: false,
                    enableGrouping: false,
                    enableColumnFilter: false,
                    enableEditing: false,
                },
            ];
            if (admin && !cloudModuleFromHeader && itemId !== "listJobEdge") {
                baseColumns.splice(1, 0, {
                    id: "subTypeMaterial",
                    header: `Подтип материала`,
                    accessorKey: 'subTypeMaterial',
                    enableColumnActions: false,
                    enableEditing: false,
                    size: 8,
                    Cell: ({cell}) => allSubMaterials.find(el => el[0] === cell.getValue())[1],
                });
            }

            if (!admin && !cloudModuleFromHeader) {
                baseColumns.splice(1, 0, {
                    id: "basePrice",
                    header: `Стоимость: ${baseCurrency}`,
                    accessorFn: (row) => row.basePrice?.price,
                    enableColumnActions: false,
                    enableEditing: false,
                    size: 8,
                    Cell: ({cell, row}) => {
                        const value = cell.getValue();
                        return value === null || value === undefined ? '-' : value.toFixed(2)
                    },
                });
                baseColumns.splice(2, 0, {
                    id: "alternativePrice",
                    header: `Стоимость: ${alternativeCurrency}`,
                    accessorFn: (row) => row.alternativePrice?.price,
                    enableColumnActions: false,
                    enableEditing: false,
                    size: 8,
                    Cell: ({cell, row}) => {
                        const value = cell.getValue();
                        return value === null || value === undefined ? '-' : value.toFixed(2)
                    },
                },);
            }
            if (admin && !cloudModuleFromHeader && !isModal) {
                baseColumns.splice(4, 0, {
                    id: 'compactPlate',
                    header: 'Компактная пластина',
                    accessorKey: 'compactPlate',
                    size: 8,
                    filterVariant: 'checkbox',
                    Cell: ({cell, row}) => <Checkbox
                        cell={cell}
                        checked={row.original.compactPlate}
                        id={row.original.id}
                        sx={{padding: "7px", '& .MuiSvgIcon-root': {fontSize: 22}}}
                    >
                    </Checkbox>,
                    // muiFilterCheckboxProps: {
                    //     slotProps: {
                    //         textField: {
                    //             placeholder: 'Отфильтровать',
                    //         }
                    //     }
                    // }

                });
                baseColumns.splice(5, 0, {
                    id: 'necessarily',
                    header: 'Обязательный',
                    accessorKey: 'necessarily',
                    enableColumnActions: false,
                    enableEditing: false,
                    size: 8,
                    filterVariant: 'checkbox',
                    Cell: ({cell, row}) => <Checkbox
                        cell={cell}
                        checked={row.original.necessarily}
                        id={row.original.id}
                        sx={{padding: "7px", '& .MuiSvgIcon-root': {fontSize: 22}}}
                    >
                    </Checkbox>,
                });
                baseColumns.splice(6, 0, {
                    id: 'display',
                    header: 'Видимость',
                    accessorKey: 'display',
                    enableColumnActions: false,
                    enableEditing: false,
                    size: 8,
                    filterVariant: 'checkbox',
                    Cell: ({cell, row}) => <Checkbox
                        cell={cell}
                        checked={row.original.display}
                        id={row.original.id}
                        sx={{padding: "7px", '& .MuiSvgIcon-root': {fontSize: 22}}}
                    >
                    </Checkbox>,
                });
                baseColumns.splice(7, 0, {
                    id: 'detail',
                    header: 'Деталь',
                    accessorKey: 'detail',
                    enableColumnActions: false,
                    enableEditing: false,
                    size: 8,
                    filterVariant: 'checkbox',
                    Cell: ({cell, row}) => <Checkbox
                        cell={cell}
                        checked={row.original.detail}
                        id={row.original.id}
                        sx={{padding: "7px", '& .MuiSvgIcon-root': {fontSize: 22}}}
                    >
                    </Checkbox>,
                });
            }
            if (admin && !cloudModuleFromHeader && (itemId === "listJobMilling" || itemId === "listJobEdge") && !isModal) {
                baseColumns.splice(4, 0, {
                    id: "restrictionsQuantityFrom",
                    header: 'Количество от',
                    accessorKey: 'restrictionsQuantityFrom',
                    enableColumnActions: false,
                    enableEditing: false,
                    size: 8,
                });
                baseColumns.splice(5, 0, {
                    id: "restrictionsQuantityTo",
                    header: 'Количество до',
                    accessorKey: 'restrictionsQuantityTo',
                    enableColumnActions: false,
                    enableEditing: false,
                    size: 8,
                })
            }

            if (admin && !cloudModuleFromHeader && itemId === "listJobMilling" && !isModal) {
                baseColumns.splice(4, 0, {
                    id: "thicknessMaterialFrom",
                    header: 'Толщина материала от',
                    accessorKey: 'thicknessMaterialFrom',
                    enableColumnActions: false,
                    enableEditing: false,
                    minSize: "150px",
                });
                baseColumns.splice(5, 0, {
                    id: "thicknessMaterialTo",
                    header: 'Толщина материала до',
                    accessorKey: 'thicknessMaterialTo',
                    enableColumnActions: false,
                    enableEditing: false,
                    minSize: "150px",
                })
                baseColumns.splice(9, 0, {
                    id: 'millingEnd',
                    header: 'Конец фрезирования',
                    accessorKey: 'millingEnd',
                    enableColumnActions: false,
                    enableEditing: false,
                    size: 8,
                    filterVariant: 'checkbox',
                    Cell: ({cell, row}) => <Checkbox
                        cell={cell}
                        checked={row.original.millingEnd}
                        id={row.original.id}
                        sx={{padding: "7px", '& .MuiSvgIcon-root': {fontSize: 22}}}
                    >
                    </Checkbox>,
                });
                baseColumns.splice(4, 0, {
                    id: "millingJob",
                    header: 'Работа фрезой',
                    accessorKey: 'millingJob',
                    enableColumnActions: false,
                    enableEditing: false,
                    size: 8,
                    Cell: ({cell}) => millingJob[cell.getValue()],
                });
                baseColumns.splice(4, 0, {
                    id: "grooveType",
                    header: 'Тип паза',
                    accessorKey: 'grooveType',
                    enableColumnActions: false,
                    enableEditing: false,
                    size: 8,
                    Cell: ({cell}) => grooveType[cell.getValue()],
                });
                baseColumns.splice(4, 0, {
                    id: "contourType",
                    header: 'Тип контура',
                    accessorKey: 'contourType',
                    enableColumnActions: false,
                    enableEditing: false,
                    size: 8,
                    Cell: ({cell}) => contourType[cell.getValue()],
                });
                baseColumns.splice(4, 0, {
                    id: "tool",
                    header: 'Инструмент',
                    accessorKey: 'tool',
                    enableColumnActions: false,
                    enableEditing: false,
                    size: 8,
                    Cell: ({cell}) => toolType[cell.getValue()],
                });
            }
            if (admin && !cloudModuleFromHeader && itemId === "listJobDrilling" && !isModal) {
                baseColumns.splice(4, 0, {
                    id: "diameterHoleFrom",
                    header: 'Диаметр тверстия от',
                    accessorKey: 'diameterHoleFrom',
                    enableColumnActions: false,
                    enableEditing: false,
                    minSize: "150px",
                });
                baseColumns.splice(4, 0, {
                    id: "diameterHoleTo",
                    header: 'Диаметр тверстия до',
                    accessorKey: 'diameterHoleTo',
                    enableColumnActions: false,
                    enableEditing: false,
                    minSize: "150px",
                });
                baseColumns.splice(4, 0, {
                    id: "depthHoleFrom",
                    header: 'Глубина тверстия от',
                    accessorKey: 'depthHoleFrom',
                    enableColumnActions: false,
                    enableEditing: false,
                    minSize: "150px",
                });
                baseColumns.splice(4, 0, {
                    id: "depthHoleTo",
                    header: 'Диаметр тверстия до',
                    accessorKey: 'depthHoleTo',
                    enableColumnActions: false,
                    enableEditing: false,
                    minSize: "150px",
                });
                baseColumns.splice(8, 0, {
                    id: "drillingEnd",
                    header: 'Торец',
                    accessorKey: 'drillingEnd',
                    enableColumnActions: false,
                    enableEditing: false,
                    minSize: "150px",
                    filterVariant: 'checkbox',
                    Cell: ({cell, row}) => <Checkbox
                        cell={cell}
                        checked={row.original.drillingEnd}
                        id={row.original.id}
                        sx={{padding: "7px", '& .MuiSvgIcon-root': {fontSize: 22}}}
                    >
                    </Checkbox>,
                });
                baseColumns.splice(9, 0, {
                    id: "overSizedPart",
                    header: 'Большегабаритная деталь',
                    accessorKey: 'overSizedPart',
                    enableColumnActions: false,
                    enableEditing: false,
                    minSize: "150px",
                    filterVariant: 'checkbox',
                    Cell: ({cell, row}) => <Checkbox
                        cell={cell}
                        checked={row.original.overSizedPart}
                        id={row.original.id}
                        sx={{padding: "7px", '& .MuiSvgIcon-root': {fontSize: 22}}}
                    >
                    </Checkbox>,
                });
                baseColumns.splice(10, 0, {
                    id: "smallSizedPart",
                    header: 'Малогабаритная деталь',
                    accessorKey: 'smallSizedPart',
                    enableColumnActions: false,
                    enableEditing: false,
                    minSize: "150px",
                    filterVariant: 'checkbox',
                    Cell: ({cell, row}) => <Checkbox
                        cell={cell}
                        checked={row.original.smallSizedPart}
                        id={row.original.id}
                        sx={{padding: "7px", '& .MuiSvgIcon-root': {fontSize: 22}}}
                    >
                    </Checkbox>,
                });
            }
            if (admin && !cloudModuleFromHeader && itemId === "listJobEdge" && !isModal) {
                baseColumns.splice(4, 0, {
                    id: "edgeJob",
                    header: 'Работа',
                    accessorKey: 'edgeJob',
                    enableColumnActions: false,
                    enableEditing: false,
                    size: 8,
                    Cell: ({cell}) => edgeJob[cell.getValue()],
                });
                baseColumns.splice(4, 0, {
                    id: "edgeEnd",
                    header: 'Край',
                    accessorKey: 'edgeEnd',
                    enableColumnActions: false,
                    enableEditing: false,
                    size: 8,
                    Cell: ({cell}) => edgeEnd[cell.getValue()],
                });
                baseColumns.splice(4, 0, {
                    id: "edgeType",
                    header: 'Тип',
                    accessorKey: 'edgeType',
                    enableColumnActions: false,
                    enableEditing: false,
                    size: 8,
                    Cell: ({cell}) => gluing[cell.getValue()],
                });
                baseColumns.splice(9, 0, {
                    id: "curvilinearEdge",
                    header: `Криволинейный край`,
                    accessorKey: 'curvilinearEdge',
                    enableColumnActions: false,
                    enableEditing: false,
                    size: 8,
                    filterVariant: 'checkbox',
                    Cell: ({cell, row}) => <Checkbox
                        cell={cell}
                        checked={row.original.curvilinearEdge}
                        id={row.original.id}
                        sx={{padding: "7px", '& .MuiSvgIcon-root': {fontSize: 22}}}
                    >
                    </Checkbox>,
                });
            }
            if (isUnit || admin) {
                baseColumns.splice(3, 0, {
                    id: "unit",
                    header: 'Ед.изм.',
                    accessorKey: 'unit',
                    accessorFn: (row) => row.unit?.name,
                    enableColumnActions: false,
                    enableEditing: false,
                    size: 8,
                });
            }
            if (!isModal && !admin) {
                baseColumns.splice(0, 0, {
                    id: "added",
                    header: 'Добавлен',
                    accessorKey: 'added',
                    enableColumnActions: false,
                    enableEditing: false,
                    size: 8,
                    filterVariant: 'checkbox',
                    Cell: ({cell, row}) => <Checkbox
                        cell={cell}
                        checked={row.original.added}
                        id={row.original.id}
                        sx={{padding: "7px", '& .MuiSvgIcon-root': {fontSize: 22}}}
                        onChange={() => handleChange(row.original)}
                        disabled={row.original.blockDelete && row.original.added === true}
                    >
                    </Checkbox>,
                });
            }
            return baseColumns;

        }, [data, setData, isPrice, isUnit, filteredData]);

        const menuItem = admin ? [
            {type: "edit", text: "Редактировать", handler: handleEdit},
            {type: "delete", text: "Удалить", handler: handleDelete}
        ] : [
            {type: "edit", text: "Редактировать", handler: handleEdit},
        ]

        return (
            <Box
                sx={{
                    overflow: 'auto',
                    maxWidth: (itemId === "listJobPacking" || itemId === "listJobCutting") && cloudModuleFromHeader ? `950px` :
                        cloudModuleFromHeader ? `1370px` :
                            (itemId === "listJobPacking" || itemId === "listJobCutting") ? "1850px" :
                                !settings ? "2700px" :
                                    `calc(100vw - 410px)`
                }}>
                <Box
                    sx={{display: 'flex', justifyContent: "space-between", paddingBottom: "30px"}}
                >
                    {!isModal && <Typography sx={{fontSize: "24px", fontWeight: 700}}>Наименования работ</Typography>}
                    {!notAuthorized && ((admin && !isModal) || addJob) && !readOnly && <ButtonCreate
                        text={"Добавить работу"}
                        width={190}
                        onClick={handleAdd}
                    />}
                </Box>
                <MaterialReactTable
                    selectAllMode={"all"}
                    muiTableContainerProps={{
                        sx: {
                            width: added ? "1800px" : isModal || fullWidth ? "100%" : `calc(100vw - 450px)`,
                            maxHeight:
                                isModal ? "530px" :
                                    settings ? `calc(100vh - 420px)` :
                                        admin && rowSelection.length > 0 ? `calc(100vh - 720px)` :
                                            admin ? `calc(100vh - 620px)` :
                                                !(enableRowSelection && !notAuthorized && !readOnly) ? `calc(100vh - 620px)` :
                                                    rowSelection.length > 0 ? `calc(100vh - 650px)` :
                                                        `calc(100vh - 550px)`,
                        }
                    }}
                    muiSearchTextFieldProps={{
                        placeholder: `Поиск`,
                        sx: {
                            paddingTop: "5px",
                            paddingBottom: "0px",
                            "& .MuiCollapse-root": {
                                borderRadius: '12px',
                                height: 40, width: 290,
                                "& .MuiSvgIcon-root": {
                                    color: "#737478"
                                },
                                '& .MuiOutlinedInput-input': {
                                    padding: 0
                                }
                            }
                        },
                        variant: 'outlined',
                    }}
                    renderTopToolbar={({table}) => {
                        return <Box sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "7px",
                            backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                        }}>
                            <MRT_ToolbarAlertBanner table={table}/>
                            <Box sx={{display: "flex"}}>
                                <MRT_ToggleFiltersButton table={table}/>
                                <MRT_GlobalFilterTextField table={table}/>
                            </Box>
                        </Box>
                    }}
                    muiToolbarAlertBannerProps={{
                        sx: {
                            backgroundColor: (theme) => theme.palette.primary.light,
                            "& .MuiStack-root": {
                                padding: 0,
                            },

                        }
                    }}
                    muiTableBodyCellProps={({cell}) => {
                        return ({
                            sx: () => ({
                                p: cell.column.id === "added" ? 0 : '0px 0px 0px 10px',
                                textAlign: cell.column.id === "added" ? "center" : "left",
                                m: '0px 0px 0px 0px',
                                border: "none",
                                "&:after": {
                                    display: "none",
                                },
                                "& td:after": {
                                    "&:hover": {
                                        backgroundColor: "red"
                                    }
                                },
                                "&:not(:last-of-type)": {
                                    borderRight: '1px solid #EAEBEA',
                                },
                                "&:first-of-type": (columnAdded || admin) && !notAuthorized && {
                                    padding: 0,
                                    width: rowActions ? "50px" : 'calc(100% - 1px)',
                                    height: "36px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    "& .MuiButtonBase-root": {
                                        borderRadius: "4px",
                                        width: "24px",
                                        height: "24px",
                                        opacity: 1,
                                        margin: 0,
                                        padding: 0,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.stroke,
                                        }
                                    }
                                },
                                "& li": {
                                    listStyleType: "none",
                                },
                                "& a": {
                                    color: "#006CCC",
                                    textDecoration: "none",
                                    "&:hover": {
                                        textDecoration: "underline"
                                    }
                                }

                            })
                        })
                    }}
                    muiTableHeadCellProps={{
                        sx: {
                            border: '1px solid #EAEBEA',
                            backgroundColor: "#F5F6FA",
                            padding: "10px",
                            paddingBottom: " 0.2rem",
                            paddingTop: "0.2rem",
                            "& .MuiCollapse-root .MuiSelect-select": {
                                padding: "0 !important",
                                "& .MuiChip-label": {
                                    paddingLeft: "5px",
                                    paddingRight: "5px",
                                }
                            }
                        },
                    }}
                    muiTableBodyRowProps={({row}) => {
                        const warningString = row.original.addedInTypeJob > 0
                        return ({
                            onClick: () => setSelectedString && isModal && setSelectedString(row.original),
                            sx: () => ({
                                height: '36px',
                                cursor: setSelectedString && isModal && "pointer",
                                opacity: !row.original?.added && !isModal && !admin && columnAdded && 0.6,
                                "&:hover& td:after": {
                                    display: "none",
                                },
                                '&:nth-of-type(even)': {
                                    backgroundColor: row.original.id === selectedString?.id ? (theme) => theme.palette.primary.light : warningString ? "rgb(255, 203, 127);" : (theme) => theme.palette.primary.lightGrey,
                                    "&.MuiTableRow-root.Mui-selected": {
                                        backgroundColor: warningString ? "rgb(255, 203, 127);" : (theme) => theme.palette.primary.light,
                                        "&:hover": {
                                            backgroundColor: warningString ? "rgb(255, 203, 127);" : (theme) => theme.palette.primary.light50,
                                        },
                                    },
                                    "&:hover": {
                                        backgroundColor: row.original.id === selectedString?.id ? (theme) => theme.palette.primary.light50 : warningString ? "rgb(255, 203, 127);" : (theme) => theme.palette.primary.stroke,
                                    },
                                },
                                backgroundColor: row.original.id === selectedString?.id ? (theme) => theme.palette.primary.light : warningString ? "rgb(255, 203, 127);" : "white",
                                "&:hover": {
                                    backgroundColor: row.original.id === selectedString?.id ? (theme) => theme.palette.primary.light50 : warningString ? "rgb(255, 203, 127);" : (theme) => theme.palette.primary.stroke,
                                },
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: warningString ? "rgb(255, 203, 127);" : (theme) => theme.palette.primary.light70,
                                    "&:hover": {
                                        backgroundColor: warningString ? "rgb(255, 203, 127);" : (theme) => theme.palette.primary.light50,
                                    },
                                },
                            })
                        })
                    }}
                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            header: "",
                            size: 3,
                            minSize: 3,
                            grow: false,
                        },
                        'mrt-row-select': {
                            size: "50px",
                            grow: false,
                        },
                    }}
                    columns={columns}
                    data={filteredData}
                    rowHeight={13}
                    columnSpacing={1}
                    initialState={{
                        expanded: false,
                        columnVisibility: {
                            id: false,
                            added: columnAdded && !admin,
                            "basePrice": !onlyName && !admin,
                            "alternativePrice": !onlyName && !admin,
                            "orderJobType": !onlyName,
                            "modelParameterUnit": !onlyName,
                        },
                        isFullScreen: false,
                        density: "compact",
                        pagination: {pageIndex: 0, pageSize: 100},
                        sorting: isModal ?
                            [] :
                            [{id: 'added', desc: true}, {id: 'orderJobType', desc: false}],
                    }}
                    onRowSelectionChange={onRowSelectionChange}
                    onPaginationChange={(updater) => {
                        tableOptionsHandle(updater(tableOptions));
                    }}
                    onGlobalFilterChange={(value) => {
                        handleSearchQuery(value, data, null)
                    }}
                    onColumnFiltersChange={(updater) => {
                        handleSearchQuery(updater(columnsFilter), data, null, true)
                    }}
                    onShowColumnFiltersChange={handleShowColumnFilters}
                    state={{
                        showColumnFilters: showColumnFilters,
                        columnFilters: columnsFilter,
                        globalFilter: globalFilter,
                        rowSelection: currentSelection,
                        showGlobalFilter: true,
                        pagination: tableOptions,
                    }}
                    manualFiltering={true}
                    rowCount={tableOptions.totalElements}
                    enableRowSelection={enableRowSelection && !notAuthorized && !readOnly}
                    getRowId={(originalRow) => originalRow.id}
                    localization={MRT_Localization_RU}
                    enableEditing={enableEditing}
                    enableToolbarInternalActions={false}
                    enableRowActions={!isModal && rowActions}
                    renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                        const enabled = admin || row.original?.added
                        return <MenuItem
                            key={el.type}
                            disabled={!enabled}
                            onClick={() => {
                                el.handler(row.original)
                                closeMenu();
                            }}
                            sx={{
                                margin: "0 8px",
                                borderRadius: "4px",
                                "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                            }}
                        >
                            {el.text}
                        </MenuItem>
                    })}
                    renderTopToolbarCustomActions={({table}) => {
                        const chooseSignJob = () => {
                            const selectedRows = table.getSelectedRowModel().flatRows;
                            const selectedIds = selectedRows.map((row) => row.getValue('id'));
                            const selectedIndexRows = selectedRows.map((row) => row.index);
                            setSelectedIds(selectedIds);
                            setRowIndexSelection(selectedIndexRows);
                            // setShowConfirmAddSignJob(true)
                        };

                        return (
                            <div>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        gap: '0.5rem',
                                        paddingLeft: '0.5rem',
                                        paddingTop: '0.5rem',
                                        paddingBottom: '0.2rem',
                                        flexWrap: 'wrap',
                                    }}
                                >
                                    {isRedirectSettings && <Button
                                        size="small"
                                        color="secondary"
                                        onClick={redirectSettings}
                                        variant="contained"
                                    >
                                        Вернуться в настройки
                                    </Button>}
                                    {isChooseSignJob && <Button
                                        size="small"
                                        color="secondary"
                                        onClick={chooseSignJob}
                                        variant="contained"
                                        disabled={table.getSelectedRowModel().rows.length === 0}
                                    >
                                        Установить
                                    </Button>}
                                    {/*{uploadSignJob && <UploadSignJobFileForm*/}
                                    {/*    label={'Загрузить операции'}*/}
                                    {/*    change={change}*/}
                                    {/*    setChange={setChange}*/}
                                    {/*/>}*/}
                                </Box>
                            </div>
                        );
                    }}
                />
                {!isModal && <ModalChooseJob
                    title={currentEditRowData?.added ? "Задать новую стоимость" : "Добавить работу"}
                    open={modalChooseJob}
                    onClose={() => setModalChooseJob(false)}
                    handleSubmit={currentEditRowData?.added ? handleEditPrice : handleSubmitAddSign}
                    currencies={currencies}
                    handleModalAlert={handleModalAlert}
                    currentEditRowData={currentEditRowData}
                    baseCurrency={baseCurrency}
                    alternativeCurrency={alternativeCurrency}
                    loading={loading}
                />}
                {modalAddInAdmin && <ModalAddJobInAdmin
                    title={currentEditRowData?.id ? "Изменить" : "Добавить"}
                    open={modalAddInAdmin}
                    onClose={() => setModalAddInAdmin(false)}
                    handleSubmit={handleSubmitModalAdmin}
                    currentEditRowData={currentEditRowData}
                    columns={columns}
                    allSubMaterials={allSubMaterials}
                    loading={loading}
                />}
                {modalAddJob && <ModalAddJob
                    open={modalAddJob}
                    onClose={() => setModalAddJob(false)}
                    onSubmit={handleSubmitAddJob}
                    handleModalAlert={handleModalAlert}
                    baseCurrency={baseCurrency}
                    alternativeCurrency={alternativeCurrency}
                    materialOrganizationOptionId={id}
                    type={type}
                    admin={admin}
                    itemId={itemId}
                    loading={loading}
                />}
            </Box>
        );
    }
;


export default JobMetricOrganizationTable;